import { FC } from "react";
import CustomModal from "../../common/custom-modal/custom-modal";
import { Colors } from "../../../configs";
import PrintCopyButtons, { PrintCopyChoice, PrintFeedback } from "./PrintCopyButtons";

interface IPrintReceiptPromptModalProps {
    open: boolean;
    title: string;
    message?: string;
    onPrintSelect: (copy: PrintCopyChoice) => void;
    printingCopy?: PrintCopyChoice | null;
    printFeedback?: PrintFeedback | null;
    onDone: () => void;
}

// End-of-transaction print choices for flows that have no "Payment Complete"
// popup of their own (a partial payment, an edited bill).
const PrintReceiptPromptModal: FC<IPrintReceiptPromptModalProps> = ({
    open, title, message, onPrintSelect, printingCopy, printFeedback, onDone,
}) => {
    const handleDone = () => {
        onPrintSelect("none");
        onDone();
    };

    return (
        <CustomModal
            title={title}
            openModal={open}
            onClose={handleDone}
            width="38rem"
            height="auto"
        >
            <div className="flex flex-col pb-[0.25rem] pt-[0.25rem]">
                {message && (
                    <div
                        className="mb-[1rem] rounded-[0.75rem] p-[1rem] text-center font-semibold"
                        style={{ backgroundColor: "#F4F5F6", color: "#515151", fontSize: "var(--fs-2xs)" }}
                    >
                        {message}
                    </div>
                )}

                <PrintCopyButtons
                    onPrintSelect={onPrintSelect}
                    printingCopy={printingCopy}
                    printFeedback={printFeedback}
                />

                <button
                    type="button"
                    onClick={handleDone}
                    className="mt-[0.5rem] h-[2.75rem] w-full rounded-[0.5625rem] font-bold text-white shadow-sm transition hover:brightness-105"
                    style={{ backgroundColor: Colors.PRIMARY, fontSize: "var(--fs-xs)" }}
                >
                    Done
                </button>
            </div>
        </CustomModal>
    );
};

export default PrintReceiptPromptModal;
